// @ts-strict-ignore
import { RequestState } from '@app/_shared/interfaces';
import { replaceById } from '@app/_shared/support';
import { ActionCreator, ReducerTypes, on } from '@ngrx/store';
import { State } from '../bootstrap.reducer';
import * as subscriptionsActions from './subscription.actions';

export function getSubscriptionOns(): ReducerTypes<State, ActionCreator[]>[] {
  return [
    on(subscriptionsActions.updateSubscription, subscriptionsActions.createSubscription, (state) => ({
      ...state,
      requestState: RequestState.SAVING,
    })),
    on(
      subscriptionsActions.updateSubscriptionSuccess,
      subscriptionsActions.createSubscriptionSuccess,
      (state, action) => {
        const stateCompany = state.company;
        if (!stateCompany) return state;
        let updatedStore = stateCompany.attributes.stores.find(
          (store) => store.id === action.response.attributes.store_id,
        );
        if (!updatedStore) return state;
        updatedStore = { ...updatedStore, attributes: { ...updatedStore.attributes, subscriptions: action.response } };
        if (updatedStore.attributes.subscriptions.attributes.billing_driver === 'shopify')
          return { ...state, requestState: RequestState.INIT };

        return {
          ...state,
          company: {
            ...stateCompany,
            attributes: {
              ...stateCompany.attributes,
              stores: replaceById(stateCompany.attributes.stores, updatedStore.id, updatedStore),
            },
          },
          requestState: RequestState.INIT,
        };
      },
    ),
    on(subscriptionsActions.refreshSubscriptionSuccess, (state, action) => {
      const stateCompany = state.company;
      if (!stateCompany) return state;
      const store = stateCompany.attributes.stores.find((s) => s.id === action.response.attributes.store_id);
      if (!store) return state;
      const updatedStore = { ...store, attributes: { ...store.attributes, subscriptions: action.response } };
      return {
        ...state,
        company: {
          ...stateCompany,
          attributes: {
            ...stateCompany.attributes,
            stores: replaceById(stateCompany.attributes.stores, updatedStore.id, updatedStore),
          },
        },
      };
    }),
    on(
      subscriptionsActions.updateSubscriptionFailed,
      subscriptionsActions.createSubscriptionFailed,
      (state, action) => ({
        ...state,
        requestState: action.error,
      }),
    ),
  ];
}
